<template>
  <section id="admin-filter">
    <h4>User Group filter</h4>
    <div class="form-group">
      <label for="pa-name" class="form-label">User login</label>
      <input type="text" class="form-control" id="pa-name" v-model="entity.userLogin"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'UserFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          userLogin: ''
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// UserFilter.vue?204bdb32